
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cLD3i", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

var $1c29116e9d0757b6$export$f067415f668a97e9 = /*#__PURE__*/ function(TestId) {
    TestId["DIALOG"] = "analytics-dialog";
    // CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
    TestId["DIALOG_SKELETON"] = "analytics-dialog-skeleton";
    TestId["LINK"] = "analytics-link";
    TestId["LINK_SKELETON"] = "analytics-link-skeleton";
    TestId["CLOSE_BUTTON"] = "dialog-close-button";
    TestId["PILLS"] = "analytics-pills";
    TestId["INFO_PANEL_1"] = "analytics-info-panel-1";
    TestId["INFO_PANEL_2"] = "analytics-info-panel-2";
    TestId["CHART"] = "analytics-chart";
    TestId["USER_LIST"] = "analytics-user-list";
    TestId["SUMMARIZE_CHANGES"] = "analytics-summarize-changes";
    return TestId;
}({});
const $1c29116e9d0757b6$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    dialogContainerAriaLabel: {
        id: "confluence-analytics.dialog.container-aria-label",
        defaultMessage: "Confluence Analytics"
    },
    dialogLoadingText: {
        id: "confluence-analytics.dialog.loading",
        defaultMessage: "Loading data..."
    },
    dialogLoadingTextMentioned: {
        id: "confluence-analytics.dialog.loading.mentioned",
        defaultMessage: "Loading mentions data..."
    },
    dialogMentionedUsersViewed: {
        id: "confluence-analytics.dialog.mentioned-users-viewed",
        defaultMessage: "mentioned {seenMentionedUsersCount, plural, one {user} other {users}} viewed this page"
    },
    dialogMentionedUsersAllSeen: {
        id: "confluence-analytics.dialog.mentioned-users-all-seen",
        defaultMessage: "Everyone mentioned has viewed"
    },
    dialogProgressbarCountAriaLabel: {
        id: "confluence-analytics.dialog.progress-bar.count-aria-label",
        defaultMessage: "{seenMentionedUsersCount} of {totalMentionedUsersCount} mentioned {seenMentionedUsersCount, plural, one {user} other {users}} viewed this page"
    },
    dialogProgressbarAriaLabel: {
        id: "confluence-analytics.dialog.progress-bar-aria-label",
        defaultMessage: "Mentioned users progress bar"
    },
    graphGranularityWeek: {
        id: "confluence-analytics.graph.granularity.week",
        defaultMessage: "Week of {date}"
    },
    graphCreatedAtDateTimeLabel: {
        id: "confluence-analytics.graph.label.created-at",
        defaultMessage: "Created {date} at {time}"
    },
    graphDateToDateTimeLabel: {
        id: "confluence-analytics.graph.label.date-to-datetime",
        defaultMessage: "{fromDate} to {toDate} ({toTime})"
    },
    lastViewedJustNow: {
        id: "confluence-analytics.dialog.viewers-list.viewed-just-now",
        defaultMessage: "Just now"
    },
    lastViewedMinutesAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-minutes-ago",
        defaultMessage: "{minuteCount} {minuteCount, plural, one {minute} other {minutes}} ago"
    },
    lastViewedHoursAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-hours-ago",
        defaultMessage: "{hourCount} {hourCount, plural, one {hour} other {hours}} ago"
    },
    lastViewedDaysAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-days-ago",
        defaultMessage: "{dayCount} {dayCount, plural, one {day} other {days}} ago"
    },
    lastViewedWeeksAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-weeks-ago",
        defaultMessage: "{weekCount} {weekCount, plural, one {week} other {weeks}} ago"
    },
    lastViewedMonthsAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-months-ago",
        defaultMessage: "{monthCount} {monthCount, plural, one {month} other {months}} ago"
    },
    lastViewedYearsAgo: {
        id: "confluence-analytics.dialog.viewers-list.viewed-years-ago",
        defaultMessage: "{yearCount} {yearCount, plural, one {year} other {years}} ago"
    },
    errorMessage: {
        id: "confluence-analytics.dialog.loading.error-message",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble loading analytics."
    },
    errorSuggestion: {
        id: "confluence-analytics.dialog.loading.error-suggestion",
        defaultMessage: "Refresh to try again."
    },
    viewedMentionsLabel: {
        id: "confluence-analytics.dialog.mentions-list.viewed.label",
        defaultMessage: "Viewed"
    },
    notViewedMentionsLabel: {
        id: "confluence-analytics.dialog.mentions-list.not-viewed.label",
        defaultMessage: "Not viewed"
    },
    mentionedPeopleLabel: {
        id: "confluence-analytics.dialog.mentions-list.mentioned-people.label",
        defaultMessage: "Mentioned people"
    },
    linksTabTopInboundColumnHeaderLabel: {
        id: "confluence-analytics.dialog.links-tab.inbound.column-header",
        defaultMessage: "Top Inbound Links"
    },
    linksTabTopOutboundColumnHeaderLabel: {
        id: "confluence-analytics.dialog.links-tab.outbound.column-header",
        defaultMessage: "Top Outbound Links"
    },
    linksTabClicksColumnHeaderLabel: {
        id: "confluence-analytics.dialog.links-tab.clicks.column-header",
        defaultMessage: "Clicks"
    },
    linksTabViewAllLinkLabel: {
        id: "confluence-analytics.dialog.links-tab.view-all-link",
        defaultMessage: "View all"
    },
    linksTabViewMoreButtonLabel: {
        id: "confluence-analytics.dialog.links-tab.view-more-button",
        defaultMessage: "View more insights"
    },
    linksTabNoInboundLinksMessage: {
        id: "confluence-analytics.dialog.links-tab.no-inbound-links",
        defaultMessage: "No other pages reference this page. As this page draws traffic from other sources, those links will appear here."
    },
    linksTabNoOutboundLinksMessage: {
        id: "confluence-analytics.dialog.links-tab.no-outbound-links",
        defaultMessage: "There are no outbound links on this page. When you add one, you can track its click count here."
    },
    linksTabExternalLinkContentItem: {
        id: "confluence-analytics.dialog.links-tab.external-link-content-item",
        defaultMessage: "External links"
    },
    linksTabExternalLinkContentItemInfoTooltip: {
        id: "confluence-analytics.dialog.links-tab.external-link-content-item.info.tooltip",
        defaultMessage: "Only aggregated data is available for external site links."
    },
    linksTabExternalLinkContentItemInfoTooltipLabel: {
        id: "confluence-analytics.dialog.links-tab.external-link-content-item.info.tooltip-label",
        defaultMessage: "External links tooltip button"
    },
    linksTabErrorContentItem: {
        id: "confluence-analytics.dialog.links-tab.error-content-item",
        defaultMessage: "An error occurred while loading this link. Refresh the page to try again."
    }
});
var $1c29116e9d0757b6$export$88ed889099de593c = /*#__PURE__*/ function(DialogPillName) {
    DialogPillName["VIEWS"] = "views";
    DialogPillName["MENTIONS"] = "mentions";
    DialogPillName["LINKS"] = "links";
    return DialogPillName;
}({});
const $1c29116e9d0757b6$export$fd1cbc4568cecf9e = {
    ["views"]: $1c29116e9d0757b6$export$a7357cdd1f0b0168.dialogLoadingText,
    ["mentions"]: $1c29116e9d0757b6$export$a7357cdd1f0b0168.dialogLoadingTextMentioned,
    ["links"]: $1c29116e9d0757b6$export$a7357cdd1f0b0168.dialogLoadingText
};
const $1c29116e9d0757b6$export$262e9e4f2cc23d74 = {
    ["views"]: 'Overview',
    ["mentions"]: 'Mentions',
    ["links"]: 'Links'
};
module.exports["TestId"] = $1c29116e9d0757b6$export$f067415f668a97e9;
module.exports["i18n"] = $1c29116e9d0757b6$export$a7357cdd1f0b0168;
module.exports["DialogPillName"] = $1c29116e9d0757b6$export$88ed889099de593c;
module.exports["pillToLoadingTextI18n"] = $1c29116e9d0757b6$export$fd1cbc4568cecf9e;
module.exports["dialogToPageAnalyticsTab"] = $1c29116e9d0757b6$export$262e9e4f2cc23d74;

});

parcelRegister("auSj5", function(module, exports) {

var $fTEVR = parcelRequire("fTEVR");

var $2Hy4R = parcelRequire("2Hy4R");

var $917iu = parcelRequire("917iu");

var $8uR5k = parcelRequire("8uR5k");

var $d6omw = parcelRequire("d6omw");

var $7HtfM = parcelRequire("7HtfM");

var $8igFT = parcelRequire("8igFT");

var $e0SBo = parcelRequire("e0SBo");

var $fakaf = parcelRequire("fakaf");

var $RvxIc = parcelRequire("RvxIc");


var $3Vbz9 = parcelRequire("3Vbz9");


var $422HI = parcelRequire("422HI");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $9a177c0c8e5aa505$export$a874c5d67969faf2 = /*#__PURE__*/ function(AnalyticsTimeseriesGranularity) {
    AnalyticsTimeseriesGranularity["DAY"] = "DAY";
    AnalyticsTimeseriesGranularity["HOUR"] = "HOUR";
    AnalyticsTimeseriesGranularity["MONTH"] = "MONTH";
    AnalyticsTimeseriesGranularity["WEEK"] = "WEEK";
    return AnalyticsTimeseriesGranularity;
}({});


/**
 * @generated SignedSource<<037c1ac2cb59092b0384d5d4cdf1f810>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $90c7d9d573845ddf$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});



var $cLD3i = parcelRequire("cLD3i");

const $2897f8d10319544e$export$9453b552a0dd9f7d = (data)=>data?.contentAnalyticsViewers?.count || 0;
const $2897f8d10319544e$export$6e5fbcef55ead47f = (data)=>data?.user?.confluence?.permissionType === (0, $90c7d9d573845ddf$export$8995abb8169b2cb8).INTERNAL;
const $2897f8d10319544e$export$7370b6e65675fd29 = (data, error)=>!error && data?.contentAnalyticsViewers === null;
const $2897f8d10319544e$var$PERMISSION_ERROR_CODES = [
    400,
    401,
    403
];
const $2897f8d10319544e$var$CONTENT_ERROR_CODES = [
    404
];
const $2897f8d10319544e$var$capitalizeFirstLetter = (word)=>`${word[0].toLocaleUpperCase()}${word.slice(1)}`;
const $2897f8d10319544e$var$DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
const $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS = {
    hours: {
        dayDiff: 2,
        hourDiff: 48
    },
    days: {
        dayDiff: 28
    },
    weeks: {
        dayDiff: 48
    },
    months: {
        monthDiff: 12
    }
};
const $2897f8d10319544e$var$errorContainsCodes = (error, expectedCodes)=>{
    if ((0, $422HI.isApolloError)(error)) return error.graphQLErrors.some((e)=>expectedCodes.includes(e?.extensions?.statusCode));
    else return expectedCodes.includes(error?.extensions?.statusCode);
};
const $2897f8d10319544e$export$8715824c16ceeca0 = (error)=>{
    return $2897f8d10319544e$var$errorContainsCodes(error, $2897f8d10319544e$var$PERMISSION_ERROR_CODES) || $2897f8d10319544e$var$errorContainsCodes(error, $2897f8d10319544e$var$CONTENT_ERROR_CODES);
};
const $2897f8d10319544e$export$e11674744930cd15 = (error)=>error && $2897f8d10319544e$var$errorContainsCodes(error, $2897f8d10319544e$var$PERMISSION_ERROR_CODES);
const $2897f8d10319544e$export$ff1e63df46e36894 = (edition)=>edition !== 'FREE';
const $2897f8d10319544e$export$928464f4d8995d5 = (max, contentCreatedDate, baseDate = new Date())=>{
    const earliestPossibleStartDate = $2897f8d10319544e$export$d7c08026d61d9fe2(baseDate, max);
    if ((0, $e0SBo.default)(earliestPossibleStartDate, contentCreatedDate)) return earliestPossibleStartDate;
    return contentCreatedDate;
};
const $2897f8d10319544e$export$d7c08026d61d9fe2 = (today, max)=>{
    return (0, $fTEVR.default)((0, $RvxIc.default)(today, max), {
        days: 1
    });
};
const $2897f8d10319544e$export$ef4ef1ccb99e706e = (createdAtDate)=>{
    const ageOfPageInDays = (0, $2Hy4R.default)(new Date(), createdAtDate);
    if (ageOfPageInDays <= $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS.hours.dayDiff) return (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).HOUR;
    else if (ageOfPageInDays <= $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS.days.dayDiff) return (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).DAY;
    else if (ageOfPageInDays <= $2897f8d10319544e$var$GRANULARITY_RANGE_LIMITS.weeks.dayDiff) return (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).WEEK;
    return (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).MONTH;
};
const $2897f8d10319544e$var$formatRelativeDate = (date, now = new Date(), locale)=>{
    const relativeDateFormatter = new Intl.RelativeTimeFormat(locale, {
        numeric: 'auto'
    });
    return relativeDateFormatter.format(-(0, $2Hy4R.default)(now, date), 'days');
};
const $2897f8d10319544e$var$formatIntlDate = (date, options)=>Intl.DateTimeFormat(undefined, {
        ...options.showMinutes ? {
            minute: 'numeric'
        } : {},
        ...options.showHours ? {
            hour: 'numeric'
        } : {},
        ...options.showDays ? {
            day: 'numeric'
        } : {},
        ...options.showMonths ? {
            month: 'long'
        } : {},
        ...options.showYears ? {
            year: 'numeric'
        } : {},
        hourCycle: 'h12'
    }).format(date);
const $2897f8d10319544e$var$formatSubTextDate = ({ date: date, granularity: granularity, now: now = new Date(), intl: intl })=>{
    switch(granularity){
        case (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).HOUR:
            if ((0, $2Hy4R.default)(now, date) < 2) return `${$2897f8d10319544e$var$capitalizeFirstLetter($2897f8d10319544e$var$formatRelativeDate(date, now, intl.locale))}, ${$2897f8d10319544e$var$formatIntlDate(date, {
                showHours: true
            })}`;
            return $2897f8d10319544e$var$formatIntlDate(date, {
                showMonths: true,
                showHours: true,
                showDays: true
            });
        case (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).DAY:
            return $2897f8d10319544e$var$formatIntlDate(date, {
                showMonths: true,
                showDays: true
            });
        case (0, $9a177c0c8e5aa505$export$a874c5d67969faf2).WEEK:
            const formattedIntlDate = $2897f8d10319544e$var$formatIntlDate(date, {
                showMonths: true,
                showDays: true
            });
            return intl.formatMessage((0, $cLD3i.i18n).graphGranularityWeek, {
                date: formattedIntlDate
            });
        default:
            return $2897f8d10319544e$var$formatIntlDate(date, {
                showYears: true,
                showMonths: true
            });
    }
};
const $2897f8d10319544e$export$2e9241a0bdf6c8b8 = ({ fromDate: fromDate, toDate: toDate, now: now = new Date(), intl: intl })=>{
    const hoursFromNow = (0, $8uR5k.default)(now, fromDate);
    const formattedDate = (date)=>{
        return $2897f8d10319544e$var$formatIntlDate(date, {
            showMonths: true,
            showDays: true,
            showYears: !(0, $fakaf.default)(fromDate, toDate)
        });
    };
    const formattedFromTime = $2897f8d10319544e$var$formatIntlDate(fromDate, {
        showHours: true,
        showMinutes: true
    });
    if (hoursFromNow <= 24) {
        const formattedFromDate = $2897f8d10319544e$var$formatRelativeDate(fromDate, now, intl.locale);
        return intl.formatMessage((0, $cLD3i.i18n).graphCreatedAtDateTimeLabel, {
            date: formattedFromDate,
            time: formattedFromTime
        });
    } else if (hoursFromNow < 48) {
        const formattedFromDate = formattedDate(fromDate);
        return intl.formatMessage((0, $cLD3i.i18n).graphCreatedAtDateTimeLabel, {
            date: formattedFromDate,
            time: formattedFromTime
        });
    } else {
        const formattedFromDate = formattedDate(fromDate);
        const formattedToDate = formattedDate(toDate);
        const formattedToTime = $2897f8d10319544e$var$formatRelativeDate(toDate, now, intl.locale);
        return intl.formatMessage((0, $cLD3i.i18n).graphDateToDateTimeLabel, {
            fromDate: formattedFromDate,
            toDate: formattedToDate,
            toTime: formattedToTime
        });
    }
};
const $2897f8d10319544e$export$b3ea52468069e196 = (timeZone, date)=>(0, $3Vbz9.format)(date, $2897f8d10319544e$var$DATE_FORMAT, {
        timeZone: timeZone
    });
const $2897f8d10319544e$export$232d2af64fd8eba1 = ({ graphData: graphData, granularity: granularity, now: now = new Date(), intl: intl })=>{
    return graphData.map((graphPoint)=>({
            date: $2897f8d10319544e$var$formatSubTextDate({
                date: new Date(graphPoint.date),
                granularity: granularity,
                now: now,
                intl: intl
            }),
            value: graphPoint.count
        }));
};
const $2897f8d10319544e$export$5807416f725a035e = (lastViewedAt, intl, now = new Date())=>{
    const minutesDiff = (0, $d6omw.default)(now, lastViewedAt);
    const hoursDiff = (0, $8uR5k.default)(now, lastViewedAt);
    const daysDiff = (0, $917iu.default)(now, lastViewedAt);
    const monthsDiff = (0, $7HtfM.default)(now, lastViewedAt);
    const yearsDiff = (0, $8igFT.default)(now, lastViewedAt);
    // Less than a minute, return 'now'
    if (minutesDiff < 1) return intl.formatMessage((0, $cLD3i.i18n).lastViewedJustNow);
    // Less than an hour, return minutes
    if (minutesDiff < 60) return intl.formatMessage((0, $cLD3i.i18n).lastViewedMinutesAgo, {
        minuteCount: minutesDiff
    });
    // Less than a day, return hours
    if (hoursDiff < 24) return intl.formatMessage((0, $cLD3i.i18n).lastViewedHoursAgo, {
        hourCount: hoursDiff
    });
    // Less than 31 days, return days
    if (daysDiff < 31) return intl.formatMessage((0, $cLD3i.i18n).lastViewedDaysAgo, {
        dayCount: daysDiff
    });
    // Less than a year, return months
    if (monthsDiff < 12) return intl.formatMessage((0, $cLD3i.i18n).lastViewedMonthsAgo, {
        monthCount: monthsDiff
    });
    // Anything greater than a year just return years
    return intl.formatMessage((0, $cLD3i.i18n).lastViewedYearsAgo, {
        yearCount: yearsDiff
    });
};
module.exports["getViewersCount"] = $2897f8d10319544e$export$9453b552a0dd9f7d;
module.exports["isInternalUser"] = $2897f8d10319544e$export$6e5fbcef55ead47f;
module.exports["isSSRError"] = $2897f8d10319544e$export$7370b6e65675fd29;
module.exports["isExpectedError"] = $2897f8d10319544e$export$8715824c16ceeca0;
module.exports["isPermissionError"] = $2897f8d10319544e$export$e11674744930cd15;
module.exports["isEditionAllowed"] = $2897f8d10319544e$export$ff1e63df46e36894;
module.exports["limitStartDate"] = $2897f8d10319544e$export$928464f4d8995d5;
module.exports["getGraphGranularity"] = $2897f8d10319544e$export$ef4ef1ccb99e706e;
module.exports["formatDateRange"] = $2897f8d10319544e$export$2e9241a0bdf6c8b8;
module.exports["formatInTimeZone"] = $2897f8d10319544e$export$b3ea52468069e196;
module.exports["formatGraphDates"] = $2897f8d10319544e$export$232d2af64fd8eba1;
module.exports["getLastViewedText"] = $2897f8d10319544e$export$5807416f725a035e;

});

parcelRegister("RvxIc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a0d6b153a6757f3$export$2e2bcd8739ae039);

var $da6O1 = parcelRequire("da6O1");


var $ksiqf = parcelRequire("ksiqf");


var $2aVgd = parcelRequire("2aVgd");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $0a0d6b153a6757f3$export$2e2bcd8739ae039(date, duration) {
    (0, $b5utg.default)(2, arguments);
    if (!duration || (0, $da6O1.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, $jZ39j.default)(duration.years) : 0;
    var months = duration.months ? (0, $jZ39j.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $jZ39j.default)(duration.weeks) : 0;
    var days = duration.days ? (0, $jZ39j.default)(duration.days) : 0;
    var hours = duration.hours ? (0, $jZ39j.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $jZ39j.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $jZ39j.default)(duration.seconds) : 0;
    // Subtract years and months
    var dateWithoutMonths = (0, $2aVgd.default)(date, months + years * 12);
    // Subtract weeks and days
    var dateWithoutDays = (0, $ksiqf.default)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});


//# sourceMappingURL=AnalyticsByLine.7a3b3993.js.map
